import { ReactNode } from 'react';
import clsx from 'clsx';

const gaps = { 0: '', 0.5: 'space-y-0.5', 1: 'space-y-1', 2: 'space-y-2', 3: 'space-y-3', 4: 'space-y-4', 5: 'space-y-5', 6: 'space-y-6', 8: 'space-y-8' } as const;

export function Stack({ gap = 2, className, children }: { gap?: keyof typeof gaps; className?: string; children: ReactNode }) {
  return <div className={clsx('flex flex-col', gaps[gap], className)}>{children}</div>;
}
